import * as Organisation from './OrganisationState'
import * as User from './UserState'
import languageResourcesReducer from './LanguageResourcesReducer'
import {UserState} from "./UserState";

// The top-level state object
export interface ApplicationState {
    organisation: Organisation.OrganisationState | undefined,
    user: UserState | undefined,
    language: any | undefined
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    organisation: Organisation.reducer,
    user: User.reducer,
    language: languageResourcesReducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
